<template>
  <img
    class="dollar-icon"
    src="../assets/img/dollar_green_icn.png"
    alt="Dollar Icon"
  />
</template>
